import React, { createContext, useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import WocaicaiMusic from '../assets/audio/WocaicaiMusic.mp3';
import Sounds_2 from '../assets/audio/Btn Sounds/Sounds_2.mp3';
import Sounds_5 from '../assets/audio/Btn Sounds/Sounds_5.mp3';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const audioRef = useRef(null);
  const location = useLocation();
  const clickSoundRef_Button = useRef(null);
  const clickSoundRef_Generic = useRef(null);

  useEffect(() => {
    const goFullscreen = () => {
      const elem = document.documentElement;
      if (!document.fullscreenElement) {
        if (elem.requestFullscreen) elem.requestFullscreen();
        else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
        else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
      }
    };

    const triggerFullscreen = () => {
      goFullscreen();
      if (audioRef.current && location.pathname === '/') {
        audioRef.current.play().catch((err) => {
          console.warn('Autoplay prevented:', err);
        });
      }
    };

    document.addEventListener('click', triggerFullscreen);
    document.addEventListener('touchstart', triggerFullscreen);

    return () => {
      document.removeEventListener('click', triggerFullscreen);
      document.removeEventListener('touchstart', triggerFullscreen);
    };
  }, [location.pathname]);

    useEffect(() => {
    const handleClickSound = (e) => {
      const isButtonClick =
        e.target.tagName === 'BUTTON' || e.target.closest('button');

      const soundRef = isButtonClick ? clickSoundRef_Button : clickSoundRef_Generic;

      if (soundRef.current) {
        soundRef.current.currentTime = 0;
        soundRef.current.play().catch(() => {});
      }
    };

    document.addEventListener('click', handleClickSound);
    return () => {
      document.removeEventListener('click', handleClickSound);
    };
  }, []);

  useEffect(() => {
    if (audioRef.current) {
      if (location.pathname === '/') {
        audioRef.current.play().catch(() => {});
      } else {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    }
  }, [location.pathname]);

  return (
    <UserContext.Provider value={{ user, setUser, loading, setLoading }}>
      <audio ref={audioRef} src={WocaicaiMusic} loop preload="auto" />
      <audio ref={clickSoundRef_Button} src={Sounds_5} preload="auto" />
      <audio ref={clickSoundRef_Generic} src={Sounds_2} preload="auto" />
      {children}
    </UserContext.Provider>
  );
};
